
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1A6sR", function(module, exports) {

$parcel$export(module.exports, "VERTICAL_MAX_WIDTH", () => $dc61fe5bc723aa83$export$a24d4999f7186564);
$parcel$export(module.exports, "SpotlightLayout", () => $dc61fe5bc723aa83$export$40cf3f2715085991);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $19TyP = parcelRequire("19TyP");

var $6NezJ = parcelRequire("6NezJ");

var $4cOi8 = parcelRequire("4cOi8");
const { NO_IMAGE_BACKGROUND: $dc61fe5bc723aa83$var$NO_IMAGE_BACKGROUND, SPLIT_IMAGE_LEFT: $dc61fe5bc723aa83$var$SPLIT_IMAGE_LEFT, SPLIT_IMAGE_RIGHT: $dc61fe5bc723aa83$var$SPLIT_IMAGE_RIGHT, FRAME_ABOVE_IMAGE: $dc61fe5bc723aa83$var$FRAME_ABOVE_IMAGE } = (0, $4cOi8.CommonLayout); /**
                   * The maximum width in pixels at which the layout is oriented vertically, at larger widths it is horizontal.
                   */ 
const $dc61fe5bc723aa83$export$a24d4999f7186564 = 640;
const $dc61fe5bc723aa83$var$FRAME_MAX_WIDTH = 486;
const $dc61fe5bc723aa83$var$CENTERED_FRAME_WIDTH = 364;
const $dc61fe5bc723aa83$var$WIDE_FRAME_WIDTH = 393;
const $dc61fe5bc723aa83$var$FULL_WIDTH_FRAME_WIDTH = 512;
const $dc61fe5bc723aa83$var$percentageStyles = {
    flex: "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq",
    imageSide: "_16jlidpf _1o9zidpf",
    childrenSide: "_16jlkb7n"
};
const $dc61fe5bc723aa83$var$gridStyles = {
    grid: "_1e0c11p5 _4t3i1osq _2z051n6q",
    frameChildren: "_2rkopd34 _yyhy183o _1ii7iqaa _195gxy5q",
    fullImage: "_1reo15vq _18m915vq _19itzgxb _yyhyjvu9 _1ii7jvu9 _4t3i1osq",
    roundedBorderRadius: "_2rkob7nn",
    smallFrameStyling: "_195gpxbi _p12f9mso",
    centeredFrameStyling: "_195gxy5q _1bsb1dty _p12f9mso",
    wideFrameStyling: "_195gxy5q _1bsb1m8p _p12f9mso",
    fullWidthFrameStyling: "_195gxncg _1bsb9k2i"
};
function $dc61fe5bc723aa83$var$spotlightToCssHeight(height) {
    switch(height){
        case (0, $4cOi8.Height).SMALL:
            return 248;
        case (0, $4cOi8.Height).MEDIUM:
            return 400;
        case (0, $4cOi8.Height).LARGE:
        default:
            return 620;
    }
}
var $dc61fe5bc723aa83$export$262fb604e10a6da8 = /*#__PURE__*/ function(SpotlightWidth) {
    SpotlightWidth[SpotlightWidth["SMALL"] = 356] = "SMALL";
    SpotlightWidth[SpotlightWidth["CENTERED"] = 800] = "CENTERED";
    SpotlightWidth[SpotlightWidth["WIDE"] = 1050] = "WIDE";
    SpotlightWidth[SpotlightWidth["FULL_WIDTH"] = 1840] = "FULL_WIDTH";
    return SpotlightWidth;
}({});
function $dc61fe5bc723aa83$export$e2db3adb05a4002(width) {
    if (width <= 356) return 'smallFrameStyling';
    if (width <= 800) return 'centeredFrameStyling';
    if (width <= 1050) return 'wideFrameStyling';
    return 'fullWidthFrameStyling';
}
function $dc61fe5bc723aa83$export$40cf3f2715085991({ backgroundColor: savedBackgroundColor, children: children, height: height, image: image, layout: layout, testId: testId, width: width = $dc61fe5bc723aa83$export$a24d4999f7186564 + 1, imageWidthPercentage: imageWidthPercentage = 0.5, hasRoundedCorners: hasRoundedCorners }) {
    const { getSavedThemeLocal: getSavedThemeLocal } = (0, $6NezJ.useConfluenceDependencies)();
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $19TyP.useDarkModeColors)(getSavedThemeLocal);
    const backgroundColor = getDarkModeCompatibleBackgroundColor(savedBackgroundColor);
    if (!image) layout = $dc61fe5bc723aa83$var$NO_IMAGE_BACKGROUND;
    const showVerticalLayout = width < $dc61fe5bc723aa83$export$a24d4999f7186564; // In the small-height layout, if there's an image, its width is fixed:
    let imageWidth;
    if (height === (0, $4cOi8.Height).SMALL && (layout === $dc61fe5bc723aa83$var$SPLIT_IMAGE_LEFT || layout === $dc61fe5bc723aa83$var$SPLIT_IMAGE_RIGHT)) {
        if (width >= 1024) imageWidth = 514;
        else if (width >= 768) imageWidth = 186;
        else if (width > $dc61fe5bc723aa83$export$a24d4999f7186564) imageWidth = 140;
        else imageWidth = 84;
    }
    const getFlexDirection = ()=>{
        if (showVerticalLayout) return layout === $dc61fe5bc723aa83$var$SPLIT_IMAGE_LEFT ? 'column' : 'column-reverse';
        return layout === $dc61fe5bc723aa83$var$SPLIT_IMAGE_LEFT ? 'row' : 'row-reverse';
    };
    return layout === $dc61fe5bc723aa83$var$FRAME_ABOVE_IMAGE ? /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        "data-testid": testId,
        style: {
            height: `${$dc61fe5bc723aa83$var$spotlightToCssHeight(height)}px`
        },
        className: (0, $35pXk.default)([
            $dc61fe5bc723aa83$var$gridStyles.grid
        ]),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $dc61fe5bc723aa83$var$gridStyles.fullImage,
                    hasRoundedCorners && $dc61fe5bc723aa83$var$gridStyles.roundedBorderRadius
                ]),
                children: image
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                style: {
                    backgroundColor: backgroundColor
                },
                className: (0, $35pXk.default)([
                    $dc61fe5bc723aa83$var$gridStyles.frameChildren,
                    $dc61fe5bc723aa83$var$gridStyles[$dc61fe5bc723aa83$export$e2db3adb05a4002(width)]
                ]),
                children: children
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        "data-testid": testId,
        style: {
            backgroundColor: backgroundColor,
            height: `${$dc61fe5bc723aa83$var$spotlightToCssHeight(height)}px`,
            flexDirection: getFlexDirection(),
            border: `1px solid ${"var(--ds-border, #091E4224)"}`,
            borderRadius: hasRoundedCorners ? "var(--ds-border-radius-300, 12px)" : 0
        },
        className: (0, $35pXk.default)([
            $dc61fe5bc723aa83$var$percentageStyles.flex
        ]),
        children: [
            layout !== $dc61fe5bc723aa83$var$NO_IMAGE_BACKGROUND && /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                style: {
                    flexBasis: imageWidth || `${imageWidthPercentage * 100}%`,
                    height: showVerticalLayout ? `${$dc61fe5bc723aa83$var$spotlightToCssHeight(height) * imageWidthPercentage}px` : '100%'
                },
                className: (0, $35pXk.default)([
                    $dc61fe5bc723aa83$var$percentageStyles.imageSide
                ]),
                children: image
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $dc61fe5bc723aa83$var$percentageStyles.childrenSide
                ]),
                children: children
            })
        ]
    });
}

});

parcelRegister("3VSZJ", function(module, exports) {

$parcel$export(module.exports, "SpotlightContent", () => $25abfcac2f4d9a9e$export$e0b309a29dbe6cbc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $1Whri = parcelRequire("1Whri");

var $dh538 = parcelRequire("dh538");

var $fpGTa = parcelRequire("fpGTa");
var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $19TyP = parcelRequire("19TyP");

var $6NezJ = parcelRequire("6NezJ");

var $4cOi8 = parcelRequire("4cOi8");

var $1A6sR = parcelRequire("1A6sR");

var $6k4H6 = parcelRequire("6k4H6");
const $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS = {
    small: 640,
    medium: 1400
};
const $25abfcac2f4d9a9e$var$styles = {
    baseWrapperStyles: "_4t3i1osq",
    smallStyles: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    mediumStyles: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    largeStyles: "_ca0qxncg _u5f3xncg _n3tdxncg _19bvxncg",
    largeTitle: "_11c8nf1z",
    xlargeTitle: "_11c81c04",
    xxlargeTitle: "_11c84xcc",
    titleStyles: "_k48p1pd9",
    smallFrameStyles: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    mediumFrameStyles: "_ca0q1ejb _n3td1ejb _19bvxy5q _u5f3xy5q",
    largeFrameStyles: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $25abfcac2f4d9a9e$export$c2176a81b9d23a65 = (width, layout)=>{
    if (layout === (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE) {
        if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 'smallFrameStyles';
        if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'mediumFrameStyles';
        return 'largeFrameStyles';
    }
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 'smallStyles';
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'mediumStyles';
    return 'largeStyles';
};
const $25abfcac2f4d9a9e$var$baseButtonStyles = (0, $ecnYn.xcss)({
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "5px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 5px)",
    transition: 'background 0.1s ease-out',
    borderStyle: 'solid',
    borderColor: 'color.border',
    paddingBlock: 'space.100',
    paddingInline: 'space.150',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    }
});
const $25abfcac2f4d9a9e$var$defaultButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.overlay.pressed'
    }
});
const $25abfcac2f4d9a9e$var$alternativeButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    ':hover': {
        backgroundColor: 'color.background.neutral.bold.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.bold.pressed'
    }
});
const $25abfcac2f4d9a9e$var$getTitleFontSize = (width)=>{
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 'largeTitle';
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'xlargeTitle';
    return 'xxlargeTitle';
};
const $25abfcac2f4d9a9e$var$getDescriptionSize = (width)=>{
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 'medium';
    return 'large';
};
const $25abfcac2f4d9a9e$var$getBaseLineCount = (isSplitLayout, width)=>{
    if (!isSplitLayout) return 8;
    if (width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 3;
    return 6;
};
const $25abfcac2f4d9a9e$var$getDescriptionMaxLines = (isSplitLayout, width, isButtonShown)=>{
    const lines = $25abfcac2f4d9a9e$var$getBaseLineCount(isSplitLayout, width);
    return isButtonShown ? lines - 2 : lines;
};
const $25abfcac2f4d9a9e$export$e0b309a29dbe6cbc = ({ testId: testId, width: width = (0, $1A6sR.VERTICAL_MAX_WIDTH) + 1, layout: layout, textColor: savedTextColor, title: title, description: description, isButtonShown: isButtonShown, buttonText: buttonText, link: link, buttonStyle: buttonStyle, source: source, imageWidthPercentage: imageWidthPercentage = 0.5 })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getSavedThemeLocal: getSavedThemeLocal } = (0, $6NezJ.useConfluenceDependencies)();
    const isSplitLayout = layout !== (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND && layout !== (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE;
    const isDefaultButtonStyle = buttonStyle === (0, $4cOi8.ButtonStyle).DEFAULT;
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor } = (0, $19TyP.useDarkModeColors)(getSavedThemeLocal);
    const textColor = (0, $dh538.fg)('company_hub_theming_responsiveness_fix') ? getDarkModeCompatibleTextColor(savedTextColor) : savedTextColor;
    const handleButtonClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spotlightButton',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const bodyTextMaxLines = (0, $gwFzn.useMemo)(()=>$25abfcac2f4d9a9e$var$getDescriptionMaxLines(isSplitLayout, width, isButtonShown), [
        isSplitLayout,
        width,
        isButtonShown
    ]);
    const titleMaxLines = ()=>{
        if (!description) return 5;
        if (imageWidthPercentage > 0.5 && width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small) return 2;
        return 3;
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
        grow: "fill",
        space: width < $25abfcac2f4d9a9e$var$SPOTLIGHT_BREAKPOINTS.small ? 'space.150' : 'space.200',
        alignInline: "start",
        alignBlock: "center",
        xcss: (0, $1Whri.cx)($25abfcac2f4d9a9e$var$styles.baseWrapperStyles, $25abfcac2f4d9a9e$var$styles[$25abfcac2f4d9a9e$export$c2176a81b9d23a65(width, layout)]),
        testId: testId,
        children: [
            title && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                align: "start",
                color: "inherit",
                maxLines: titleMaxLines(),
                testId: "spotlight-title",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ), {
                    style: {
                        color: textColor
                    },
                    xcss: (0, $1Whri.cx)($25abfcac2f4d9a9e$var$styles[$25abfcac2f4d9a9e$var$getTitleFontSize(width)], $25abfcac2f4d9a9e$var$styles.titleStyles),
                    children: title
                })
            }),
            description && bodyTextMaxLines > 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                style: {
                    color: textColor
                },
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                    testId: "spotlight-description",
                    align: "start",
                    color: "inherit",
                    size: $25abfcac2f4d9a9e$var$getDescriptionSize(width),
                    maxLines: bodyTextMaxLines,
                    children: description
                })
            }),
            isButtonShown && link && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpGTa.default), {
                onClick: handleButtonClick,
                href: link,
                xcss: [
                    $25abfcac2f4d9a9e$var$baseButtonStyles,
                    isDefaultButtonStyle ? $25abfcac2f4d9a9e$var$defaultButtonStyles : $25abfcac2f4d9a9e$var$alternativeButtonStyles
                ],
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                    weight: "medium",
                    color: isDefaultButtonStyle ? 'color.text' : 'color.text.inverse',
                    maxLines: 1,
                    children: buttonText || /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $6k4H6.default).placeholderButtonLabel
                    })
                })
            })
        ]
    });
};

});
parcelRegister("6k4H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a5c440fe3fe67ab$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
var $3a5c440fe3fe67ab$export$2e2bcd8739ae039 = (0, $2nPZH.defineMessages)({
    placeholderButtonLabel: {
        id: "custom-sites-extensions.spotlight.button-label.placeholder",
        defaultMessage: "View"
    }
});

});


parcelRegister("kHNfU", function(module, exports) {

$parcel$export(module.exports, "CustomImageUploadRenderer", () => $c37331190ee2a568$export$3f3413d4a48facf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $2p7B1 = parcelRequire("2p7B1");

var $3rvSa = parcelRequire("3rvSa");

var $btHGY = parcelRequire("btHGY");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6NezJ = parcelRequire("6NezJ");

var $iUrRB = parcelRequire("iUrRB");
const $c37331190ee2a568$var$errorWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    background: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c37331190ee2a568$var$ImageWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4t3i1osq _1bsb1osq _1h1tn7od _5ral1dfr",
            __cmplp.className
        ])
    });
});
const $c37331190ee2a568$var$uploadingImageStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
});
const $c37331190ee2a568$var$getImageMediaLocation = (activeContentId, maybeCustomCoverImage)=>{
    if (maybeCustomCoverImage.indexOf('/') !== -1) {
        const temp = maybeCustomCoverImage.split('/');
        return [
            temp[0],
            temp[1]
        ];
    }
    return [
        activeContentId,
        maybeCustomCoverImage
    ];
};
const $c37331190ee2a568$export$3f3413d4a48facf = ({ contentId: contentId, imageSrc: imageSrc = '', imageAltText: imageAltText, shouldShowErrorMessage: shouldShowErrorMessage = false })=>{
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent, createRendererMediaProvider: createRendererMediaProvider } = (0, $6NezJ.useConfluenceDependencies)();
    const intl = (0, $dBxQj.default)();
    const [collectionId, imageId] = $c37331190ee2a568$var$getImageMediaLocation(contentId, imageSrc);
    const mediaConfig = $c37331190ee2a568$var$useMediaConfig({
        collectionId: collectionId,
        createRendererMediaProvider: createRendererMediaProvider
    });
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    if (!mediaConfig || !mediaConfig.authProvider) return null;
    const errorState = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $c37331190ee2a568$var$errorWrapperStyles,
        testId: "custom-image-upload-error",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2p7B1))), {
                label: intl.formatMessage((0, $iUrRB.messages).warningIcon),
                color: "var(--ds-icon-subtle, #626F86)"
            }),
            shouldShowErrorMessage && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $iUrRB.messages).imageFailedMessage
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3rvSa.MediaClientProvider), {
        clientConfig: mediaConfig,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $btHGY.MediaImageWithErrorBoundary), {
            identifier: {
                mediaItemType: 'file',
                id: imageId,
                collectionName: mediaConfig?.collection
            },
            mediaClientConfig: {
                authProvider: mediaConfig.authProvider
            },
            apiConfig: {
                allowAnimated: true,
                mode: 'fit',
                upscale: false
            },
            children: ({ data: data, loading: loading, error: error })=>{
                if (loading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    testId: "custom-image-upload-loading",
                    xcss: $c37331190ee2a568$var$uploadingImageStyles
                });
                if (error || !data?.src) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        errorState,
                        /*#__PURE__*/ (0, $7UHDa.jsx)(ExperienceError, {
                            error: new Error('Image failed to load in CustomImageUploadRenderer')
                        })
                    ]
                });
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)($c37331190ee2a568$var$ImageWrapper, {
                            src: data.src,
                            alt: imageAltText,
                            "data-testid": "custom-image-upload"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)(ExperienceSuccess, {})
                    ]
                });
            }
        }, imageId)
    });
};
function $c37331190ee2a568$var$useMediaConfig({ collectionId: collectionId, createRendererMediaProvider: createRendererMediaProvider }) {
    const [mediaConfig, setMediaConfig] = (0, $gwFzn.useState)(null);
    (0, $gwFzn.useEffect)(()=>{
        async function createMediaConfig() {
            if (!createRendererMediaProvider) return;
            const { viewMediaClientConfig: viewMediaClientConfig } = await createRendererMediaProvider({
                contentId: collectionId,
                isExternalShare: false
            });
            if (!viewMediaClientConfig) {
                setMediaConfig(null);
                return;
            }
            setMediaConfig({
                collection: `contentId-${collectionId}`,
                authProvider: viewMediaClientConfig.authProvider
            });
        }
        createMediaConfig();
    }, [
        collectionId,
        createRendererMediaProvider
    ]);
    return mediaConfig;
}

});
parcelRegister("iUrRB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08582f179b34db1b$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $08582f179b34db1b$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    imageFailedMessage: {
        id: "custom-sites-extensions.link-cards.image-failed-to-load",
        defaultMessage: "Image failed to load"
    },
    warningIcon: {
        id: "custom-sites-extensions.link-cards.warning",
        defaultMessage: "Warning icon for image failed to load"
    }
});

});


parcelRegister("jqjsu", function(module, exports) {

$parcel$export(module.exports, "getImageTypeToShow", () => $04a364cca99a3e77$export$25f23b916a7baf7);

var $iqWjJ = parcelRequire("iqWjJ");
const $04a364cca99a3e77$export$25f23b916a7baf7 = ({ imageSrc: imageSrc })=>{
    const showUnsplashImage = (0, $iqWjJ.isUnsplashImage)(imageSrc);
    const showExternalSiteImage = !!imageSrc && $04a364cca99a3e77$var$externalSiteMatcher.test(imageSrc);
    const showCustomUploadedImage = !!imageSrc && !(0, $iqWjJ.isUnsplashImage)(imageSrc) && !showExternalSiteImage;
    return {
        showUnsplashImage: showUnsplashImage,
        showExternalSiteImage: showExternalSiteImage,
        showCustomUploadedImage: showCustomUploadedImage,
        hasImage: showUnsplashImage || showCustomUploadedImage || showExternalSiteImage
    };
};
const $04a364cca99a3e77$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

});
parcelRegister("iqWjJ", function(module, exports) {

$parcel$export(module.exports, "isUnsplashImage", () => $6dcf901a23b2876f$export$fc883aabd3b0aeb1);

var $2Maq7 = parcelRequire("2Maq7");
const $6dcf901a23b2876f$export$fc883aabd3b0aeb1 = (imageUrl)=>{
    if (!imageUrl) return false;
    return imageUrl?.includes((0, $2Maq7.UNSPLASH_URL));
};

});
parcelRegister("2Maq7", function(module, exports) {

$parcel$export(module.exports, "UNSPLASH_URL", () => $be60834a85e1f9eb$export$fe42ffbf1f8cac0e);
$parcel$export(module.exports, "DEFAULT_UNSPLASH_QUERY_WORD", () => $be60834a85e1f9eb$export$9d9758c15e32e47a);
$parcel$export(module.exports, "PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD", () => $be60834a85e1f9eb$export$4eb66a6321d4a29c);
const $be60834a85e1f9eb$export$fe42ffbf1f8cac0e = 'images.unsplash.com';
const $be60834a85e1f9eb$export$9d9758c15e32e47a = 'pastel gradient';
const $be60834a85e1f9eb$export$4eb66a6321d4a29c = 'color';

});



parcelRegister("evEMm", function(module, exports) {

$parcel$export(module.exports, "ImageRenderer", () => $2382e5b60fce93fb$export$a8e6523ab063becd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $6NezJ = parcelRequire("6NezJ");

var $kHNfU = parcelRequire("kHNfU");

var $jqjsu = parcelRequire("jqjsu");
const $2382e5b60fce93fb$var$unboundedStyles = {
    unsplashImage: "_4t3i1osq _1bsb1osq _5ral1dfr"
};
const $2382e5b60fce93fb$export$a8e6523ab063becd = ({ contentId: contentId, imageSrc: imageSrc, imageAlt: imageAlt, shouldShowExternalSiteImage: shouldShowExternalSiteImage })=>{
    const { experienceSuccessComponent: experienceSuccessComponent } = (0, $6NezJ.useConfluenceDependencies)();
    if (!imageSrc) return null;
    const { showUnsplashImage: showUnsplashImage, showCustomUploadedImage: showCustomUploadedImage, showExternalSiteImage: showExternalSiteImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const ExperienceSuccessComponent = experienceSuccessComponent || (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment;
    if (showUnsplashImage || shouldShowExternalSiteImage && showExternalSiteImage) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
                "data-testid": "unsplash-img-element",
                alt: imageAlt,
                src: imageSrc,
                className: (0, $35pXk.default)([
                    $2382e5b60fce93fb$var$unboundedStyles.unsplashImage
                ])
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)(ExperienceSuccessComponent, {})
        ]
    });
    else if (showCustomUploadedImage) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHNfU.CustomImageUploadRenderer), {
        contentId: contentId,
        imageSrc: imageSrc,
        imageAltText: imageAlt,
        shouldShowErrorMessage: true
    });
     // Fallback if nothing matches
    return /*#__PURE__*/ (0, $7UHDa.jsx)(ExperienceSuccessComponent, {});
};

});


//# sourceMappingURL=Carousel.6f5c819a.js.map
